<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="评价搜索：" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入商品名称/用户名称/订单编号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="时间筛选：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button @click="toAdd()" type="primary" class="bg-theme" style="margin-top: -22px;">添加自评</el-button>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="thumb"
            label="商品图片">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;margin-right: 16px;"
                :src="scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsDescriptionEvaluate"
            label="评分">
          </el-table-column>
          <el-table-column
            align="center"
            prop="evaluateDetail"
            label="内容">
          </el-table-column>
          <el-table-column
            align="center"
            prop="urlList"
            label="图片">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.urlList.length > 0"
                style="width: 40px;"
                :src="scope.row.urlList[0]"
                :preview-src-list="scope.row.urlList"
                fit="contain"></el-image>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="评价时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="merchantContent"
            label="回复内容">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.merchantContent == '' || scope.row.merchantContent == null" @click="replyOpenBtn(scope.row.id)" type="text" size="small">回复</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="添加评价"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" :rules="cateRules" label-width="140px">
        <el-form-item label="商品：" prop="goodsId">
          <el-select style="width: 420px;" v-model="cateForm.goodsId" placeholder="请选择商品">
            <el-option v-for="(item,index) in goodsList" :key="index" :label="item.apiGoodsName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="nickName">
          <el-input style="width: 420px;" v-model="cateForm.nickName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="用户头像：" prop="headPicture">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="fileList"
            :on-remove="delImgBtn.bind(null,{'type':1})"
            :on-success="uploadImgBtn">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="评价文字：" prop="evaluateDetail">
          <el-input style="width: 420px;" rows="5" type="textarea" v-model="cateForm.evaluateDetail" placeholder="请输入评价文字"></el-input>
        </el-form-item>
        <el-form-item label="评价星级：" prop="goodsDescriptionEvaluate">
          <div class="flex-row-align">
            <img class="mt-comment-star" v-for="(item,index) in qsScoreStarArr" :key="index" @click="tapStarBtn" :data-index="index" :src="imgServer+item" alt="" />
          </div>
        </el-form-item>
        <el-form-item label="评价图片：" prop="urlList">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="5"
            :file-list="fileListTwo"
            :on-remove="delImgBtn.bind(null,{'type':2})"
            :on-success="uploadImgBtnTwo">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="回复"
      :visible.sync="replyShow"
      width="960px">
      <el-form :model="replyForm" :rules="replyRules" label-width="140px">
        <el-form-item label="回复内容：" prop="reply">
          <el-input style="width: 420px;" rows="8" type="textarea" v-model="replyForm.reply" placeholder="请输入回复内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="replyBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { goodsCommentList, goodsCommentDel, goodsCommentAdd,goodsCommentReply,goodsCommentInfo } from '@/api/goodsComment'
export default {
  name: 'Goods_comment',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        date:['', '']
      },
      // 一级分类数据
      dataId:'',
      cateList:[],
      dialogVisible: false,
      cateForm:{
        goodsId:'',
        goodsDescriptionEvaluate:0,
        evaluateDetail:'',
        urlList:[],
        nickName:'',
        headPicture:''
      },
      cateRules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' }
        ],
        headPicture: [
          { required: true, message: '请上传用户头像', trigger: 'blur' }
        ],
        evaluateDetail: [
          { required: true, message: '请上传用户头像', trigger: 'blur' }
        ],
        goodsDescriptionEvaluate: [
          { required: true, message: '请选择评价星级', trigger: 'blur' }
        ]
      },
      fileList:[],
      fileListTwo:[],
      goodsList:[],
      qsScore:'',
      qsScoreStarArr:[],
      // 回复
      replyShow:false,
      replyForm:{
        reply:''
      },
      replyRules: {
        reply: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.star(this.qsScoreStarArr, 0);
    this.getInfoList()
  },
  methods: {
    uploadImgBtn(file){
      this.cateForm.headPicture = file.data.fileUrl
    },
    uploadImgBtnTwo(file){
      this.cateForm.urlList.push(file.data.fileUrl)
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 用户头像
          var headPicture = '';
          fileList.forEach(function(item){
            headPicture = item.url;
          });
          that.cateForm.headPicture = headPicture;
          break;
        case 2:
          // 评价图片
          var imgList = [];
          fileList.forEach(function(item){
            imgList.push(item.url);
          });
          that.cateForm.urlList = imgList;
          break;
      }
    },
    /* 商品小星星评价 */
    tapStarBtn:function(e){
      var index = e.currentTarget.dataset.index;
      this.qsScoreStarArr = [];
      var score = parseFloat(parseFloat(index)+1).toFixed(1);
      this.qsScore = score;
      this.cateForm.goodsDescriptionEvaluate = score;
      var that = this;
      this.star(that.qsScoreStarArr, score);
    },
    /* 小星星 */
    star(starArr, score) {
      score = parseFloat(score).toFixed(1);
      for (var i = 0; i < parseInt(score); i++) {
        starArr.push("star_active.png");
      }
      var halfNum = 0;
      if (score.toString().replace(/\d+\.(\d*)/, '$1') != 0) {
        halfNum = 1;
      }
      for (var i = 0; i < parseInt(5 - score); i++) {
        starArr.push("star_grey.png");
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      goodsCommentList({ webSearchStr: searchName,startDate:startDate,endDate:endDate,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        goodsCommentDel({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 打开回复弹窗 */
    replyOpenBtn(dataId){
      this.dataId = dataId;
      this.replyShow = true;
    },
    /* 回复操作 */
    replyBtn(){
      var that = this
      var dataId = that.dataId
      var merchantContent = that.replyForm.reply
      if (merchantContent === '') {
        this.$message.error('请输入回复内容')
        return false
      }
      let passData = {
        id: dataId, merchantContent: merchantContent
      }
      goodsCommentReply(passData).then((res) => {
        that.fullscreenLoading = false;
        that.replyRules.reply = '';
        that.replyShow = false;
        that.currentPage = 1;
        that.getInfoList();
      })
    },
    /* 添加自评-商品数据 */
    toAdd () {
      let that = this
      goodsCommentInfo().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsList = data
          that.dialogVisible = true
        }
        if (res.errorCode === '4002') {
          that.goodsList = []
          that.dialogVisible = true
        }
      })
    },
    // 添加自评操作
    saveBtn(){
      var that = this
      var goodsId = that.cateForm.goodsId
      var nickName = that.cateForm.nickName
      var headPicture = that.cateForm.headPicture
      var evaluateDetail = that.cateForm.evaluateDetail
      var goodsDescriptionEvaluate = parseInt(that.cateForm.goodsDescriptionEvaluate)
      var urlList = that.cateForm.urlList
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      if (nickName === '') {
        this.$message.error('请输入用户昵称')
        return false
      }
      if (headPicture === '') {
        this.$message.error('请上传用户头像')
        return false
      }
      if (evaluateDetail === '') {
        this.$message.error('请输入评价文字')
        return false
      }
      if (goodsDescriptionEvaluate === 0) {
        this.$message.error('请选择评价星级')
        return false
      }
      let passData = {
        goodsId: goodsId, nickName: nickName, headPicture: headPicture, evaluateDetail: evaluateDetail,goodsDescriptionEvaluate:goodsDescriptionEvaluate,urlList:urlList
      }
      goodsCommentAdd(passData).then((res) => {
        that.fullscreenLoading = false;
        that.cateForm.goodsId = '';
        that.cateForm.nickName = '';
        that.cateForm.headPicture = '';
        that.fileList = [];
        that.cateForm.evaluateDetail = '';
        that.cateForm.goodsDescriptionEvaluate = 0;
        that.cateForm.urlList = [];
        that.fileListTwo = [];
        that.dialogVisible=false;
        that.currentPage = 1;
        that.getInfoList();
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Comment.vue